<main>

<!-- Mobil: Tam ekran misafir overlay -->
<div class="mobile-guest-overlay" *ngIf="isMobileGuestOpen" (click)="$event.stopPropagation()">
  <div class="mobile-guest-overlay__header">
    <button type="button" class="mobile-guest-overlay__back" (click)="closeMobileGuest()">
      <i class="icon-arrow-left text-20"></i>
    </button>
    <span class="text-16 fw-600">Misafirler</span>
    <button type="button" class="mobile-guest-overlay__done" (click)="closeMobileGuest()">Tamam</button>
  </div>
  <div class="mobile-guest-overlay__content">
    <div class="d-flex justify-end mb-20">
      <div role="button" tabindex="0" (click)="addRoom()"
        class="d-flex items-center x-gap-10 rounded-4"
        [ngStyle]="{ border: '1px dashed #2F80ED', color: '#2F80ED', padding: '8px 14px', cursor: searchForm.get('rooms')?.value >= 2 ? 'not-allowed' : 'pointer', opacity: searchForm.get('rooms')?.value >= 2 ? 0.5 : 1 }">
        <i class="icon-plus text-12"></i>
        <span class="text-14 fw-600">Oda ekle</span>
      </div>
    </div>

    <div class="d-flex justify-between items-center">
      <div class="text-15 fw-500">Yetişkin</div>
      <div class="d-flex items-center">
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('adults', false)"><i class="icon-minus text-12"></i></button>
        <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get("adults")?.value }}</div></div>
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('adults', true)"><i class="icon-plus text-12"></i></button>
      </div>
    </div>

    <div class="border-top-light mt-24 mb-24"></div>

    <div class="d-flex justify-between items-center">
      <div>
        <div class="text-15 lh-12 fw-500">Çocuk</div>
        <div class="text-14 lh-12 text-light-1 mt-5">0 - 17 yaş</div>
      </div>
      <div class="d-flex items-center">
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('children', false)"><i class="icon-minus text-12"></i></button>
        <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get("children")?.value }}</div></div>
        <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('children', true)"><i class="icon-plus text-12"></i></button>
      </div>
    </div>

    <div *ngIf="searchForm.get('children')?.value > 0" class="mt-20">
      <div class="text-15 fw-500 mb-16">Çocuk Yaşları</div>
      <div *ngFor="let age of childrenAges; let i = index" class="d-flex justify-between items-center mb-15">
        <div class="text-14 fw-500">{{ i + 1 }}. Çocuk</div>
        <div class="d-flex items-center">
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="incrementChildAge(i, -1)"><i class="icon-minus text-12"></i></button>
          <div class="flex-center ml-15 mr-15" style="min-width: 50px; text-align: center;"><div class="text-14 fw-500">{{ age }} yaş</div></div>
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="incrementChildAge(i, 1)"><i class="icon-plus text-12"></i></button>
        </div>
      </div>
    </div>

    <div *ngIf="searchForm.get('rooms')?.value === 2">
      <div class="border-top-light mt-24 mb-24"></div>
      <div class="d-flex items-center justify-between mb-10">
        <div class="text-15 fw-600">2. Oda</div>
        <a role="button" (click)="removeRoom()" class="text-13 fw-600" style="color: #EB5757;">
          <i class="icon-minus text-12 mr-5"></i>Kaldır
        </a>
      </div>
      <div class="d-flex justify-between items-center">
        <div class="text-15 fw-500">Yetişkin</div>
        <div class="d-flex items-center">
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Adults', false)"><i class="icon-minus text-12"></i></button>
          <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get('room2Adults')?.value }}</div></div>
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Adults', true)"><i class="icon-plus text-12"></i></button>
        </div>
      </div>
      <div class="border-top-light mt-24 mb-24"></div>
      <div class="d-flex justify-between items-center">
        <div class="text-15 lh-12 fw-500">Çocuk</div>
        <div class="d-flex items-center">
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Children', false)"><i class="icon-minus text-12"></i></button>
          <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get('room2Children')?.value }}</div></div>
          <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Children', true)"><i class="icon-plus text-12"></i></button>
        </div>
      </div>
      <div *ngIf="searchForm.get('room2Children')?.value > 0" class="mt-20">
        <div class="text-15 fw-500 mb-16">2. Oda Çocuk Yaşları</div>
        <div *ngFor="let age of room2ChildrenAges; let i = index" class="d-flex justify-between items-center mb-15">
          <div class="text-14 fw-500">{{ i + 1 }}. Çocuk</div>
          <div class="d-flex items-center">
            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="incrementChildAgeRoom2(i, -1)"><i class="icon-minus text-12"></i></button>
            <div class="flex-center ml-15 mr-15" style="min-width: 50px; text-align: center;"><div class="text-14 fw-500">{{ age }} yaş</div></div>
            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="incrementChildAgeRoom2(i, 1)"><i class="icon-plus text-12"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobil: Tam ekran takvim overlay -->
<div class="mobile-calendar-overlay" *ngIf="isMobileCalendarOpen" (click)="$event.stopPropagation()">
  <div class="mobile-calendar-overlay__header">
    <button type="button" class="mobile-calendar-overlay__back" (click)="closeMobileCalendar()">
      <i class="icon-arrow-left text-20"></i>
    </button>
    <span class="text-16 fw-600">Tarih Seçin</span>
    <button type="button" class="mobile-calendar-overlay__done" (click)="closeMobileCalendar()">Tamam</button>
  </div>
  <div class="mobile-calendar-overlay__content">
    <app-date-range-picker
      [startDate]="searchForm.get('checkInDate')?.value"
      [endDate]="searchForm.get('checkOutDate')?.value"
      [isOpen]="true"
      [staticMode]="true"
      (dateRangeSelected)="onDateRangeSelected($event)">
    </app-date-range-picker>
  </div>
</div>

<!-- Mobil: Tam ekran location overlay -->
<div class="mobile-location-overlay" *ngIf="isMobileLocationOpen" (click)="$event.stopPropagation()">
  <div class="mobile-location-overlay__header">
    <button type="button" class="mobile-location-overlay__back" (click)="closeMobileLocation()">
      <i class="icon-arrow-left text-20"></i>
    </button>
    <input
      type="text"
      class="mobile-location-overlay__input"
      placeholder="Şehir, bölge veya otel adı yazın"
      [value]="mobileLocationSearch"
      (input)="onMobileLocationInput($any($event.target).value)"
      autocomplete="off" />
  </div>
  <div class="mobile-location-overlay__results">
    <!-- Mevcut arama -->
    <ng-container *ngIf="mobileLocationSearch.length === 0 && selectedLocation">
      <div class="mobile-location-overlay__section-title">Mevcut Arama</div>
      <div class="mobile-location-overlay__item" (click)="onLocationSelect(selectedLocation)">
        <i class="icon-location text-16 text-blue-1 mr-10"></i>
        <span>{{ selectedLocation.label }}</span>
      </div>
    </ng-container>

    <!-- Popüler aramalar (input boşken) -->
    <ng-container *ngIf="mobileLocationSearch.length === 0 && quickSuggestions.length > 0">
      <div class="mobile-location-overlay__section-title">Popüler Aramalar</div>
      <div *ngFor="let suggestion of quickSuggestions"
        class="mobile-location-overlay__item"
        (click)="onLocationSelect(suggestion)">
        <i class="icon-star text-16 text-blue-1 mr-10"></i>
        <span>{{ suggestion.label }}</span>
      </div>
    </ng-container>

    <!-- Arama sonuçları -->
    <ng-container *ngIf="mobileLocationSearch.length > 0">
      <div *ngFor="let location of filteredLocations$ | async"
        class="mobile-location-overlay__item"
        (click)="onLocationSelect(location)">
        <i class="icon-location text-16 text-blue-1 mr-10"></i>
        <span>{{ location.label }}</span>
      </div>
    </ng-container>
  </div>
</div>

  <section class="pb-40" style="background: linear-gradient(180deg, #EBF1FF 0%, #F5F8FF 50%, #FFFFFF 100%); position: relative; padding-top: 20px; z-index: 1001;">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="mainSearch bg-white rounded-16 shadow-search-strong mt-30">
            <form [formGroup]="searchForm" (ngSubmit)="performSearch()">
              <div class="search-grid">

                <!-- Location -->
                <div class="search-field" (click)="openMobileLocation(); $event.stopPropagation()">
                  <div class="search-field__icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  </div>
                  <div class="search-field__content">
                    <div class="search-field__label">Nereye?</div>
                    <input autocomplete="off" type="search" formControlName="location"
                      placeholder="Şehir, bölge veya otel" class="search-field__input desktop-location-input"
                      [matAutocomplete]="auto"
                      #autoTrigger="matAutocompleteTrigger"
                      (focus)="onLocationFocus()" />
                    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)="onLocationSelect($event.option.value)"
                      panelWidth="auto">
                      <mat-option *ngFor="let location of filteredLocations$ | async" [value]="location">
                        {{ location.label }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>

                <div class="search-divider"></div>

                <!-- Date -->
                <div class="search-field search-field--date">
                  <div class="search-field__trigger" (click)="toggleCalendar(); $event.stopPropagation()">
                    <div class="search-field__icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    </div>
                    <div class="search-field__content">
                      <div class="search-field__label">Tarih</div>
                      <div class="search-field__value">
                        <ng-container *ngIf="searchForm.get('checkInDate')?.value && searchForm.get('checkOutDate')?.value">
                          {{ searchForm.get('checkInDate')?.value | date:'d MMM' }} → {{ searchForm.get('checkOutDate')?.value | date:'d MMM' }}
                        </ng-container>
                        <span *ngIf="!searchForm.get('checkInDate')?.value || !searchForm.get('checkOutDate')?.value" class="search-field__placeholder">Tarih seçin</span>
                      </div>
                    </div>
                  </div>
                  <div class="desktop-calendar-dropdown" (click)="$event.stopPropagation()">
                    <div class="desktop-calendar-panel" *ngIf="isCalendarOpen">
                      <div class="desktop-calendar-body">
                        <app-date-range-picker
                          [startDate]="searchForm.get('checkInDate')?.value"
                          [endDate]="searchForm.get('checkOutDate')?.value"
                          [isOpen]="true"
                          [staticMode]="true"
                          (dateRangeSelected)="onDateRangeSelected($event)"
                          (closed)="closeCalendar()">
                        </app-date-range-picker>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="search-divider"></div>

                <!-- Guests -->
                <div class="search-field search-field--guests">
                  <div class="search-field__trigger" (click)="toggleGuestSelector(); $event.stopPropagation()">
                    <div class="search-field__icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                    </div>
                    <div class="search-field__content">
                      <div class="search-field__label">Misafir</div>
                      <div class="search-field__value">
                        {{ getTotalAdults() }} yetişkin · {{ getTotalChildren() }} çocuk · {{ searchForm.get("rooms")?.value }} oda
                      </div>
                    </div>
                  </div>
                  <div (click)="$event.stopPropagation()">
                    <div class="searchMenu-guests__field shadow-2" [class.-is-active]="isGuestSelectorOpen">
                    <div class="bg-white px-30 py-30 rounded-4">
                      <div class="d-flex justify-between items-center mb-20">
                        <div class="text-15 fw-600">Misafirler</div>
                        <div role="button" tabindex="0" (click)="addRoom()"
                          class="d-flex items-center x-gap-10 rounded-4"
                          [ngStyle]="{ border: '1px dashed #2F80ED', color: '#2F80ED', padding: '8px 14px', cursor: searchForm.get('rooms')?.value >= 2 ? 'not-allowed' : 'pointer', opacity: searchForm.get('rooms')?.value >= 2 ? 0.5 : 1 }">
                          <i class="icon-plus text-12"></i>
                          <span class="text-14 fw-600">Oda ekle</span>
                        </div>
                      </div>

                      <div class="row y-gap-10 justify-between items-center">
                        <div class="col-auto"><div class="text-15 fw-500">Yetişkin</div></div>
                        <div class="col-auto">
                          <div class="d-flex items-center">
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('adults', false)"><i class="icon-minus text-12"></i></button>
                            <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get("adults")?.value }}</div></div>
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('adults', true)"><i class="icon-plus text-12"></i></button>
                          </div>
                        </div>
                      </div>

                      <div class="border-top-light mt-24 mb-24"></div>

                      <div class="row y-gap-10 justify-between items-center">
                        <div class="col-auto">
                          <div class="text-15 lh-12 fw-500">Çocuk</div>
                          <div class="text-14 lh-12 text-light-1 mt-5">0 - 17 yaş</div>
                        </div>
                        <div class="col-auto">
                          <div class="d-flex items-center">
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('children', false)"><i class="icon-minus text-12"></i></button>
                            <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get("children")?.value }}</div></div>
                            <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCount('children', true)"><i class="icon-plus text-12"></i></button>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="searchForm.get('children')?.value > 0" class="mt-20">
                        <div class="text-15 fw-500 mb-16">Çocuk Yaşları</div>
                        <div class="children-ages-grid">
                          <div *ngFor="let age of childrenAges; let i = index" class="d-flex flex-column items-center">
                            <div class="text-12 fw-500 mb-8">{{ i + 1 }}. Çocuk</div>
                            <select class="child-age-select" (change)="onChildAgeChange($event, i)">
                              <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [value]="a" [selected]="a === age">{{ a }} yaş</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="searchForm.get('rooms')?.value === 2">
                        <div class="border-top-light mt-24 mb-24"></div>
                        <div class="d-flex items-center justify-between mb-10">
                          <div class="text-15 fw-600">2. Oda</div>
                          <a role="button" (click)="removeRoom()" class="text-13 fw-600" style="color: #EB5757;"><i class="icon-minus text-12 mr-5"></i>Kaldır</a>
                        </div>
                        <div class="row y-gap-10 justify-between items-center">
                          <div class="col-auto"><div class="text-15 fw-500">Yetişkin</div></div>
                          <div class="col-auto">
                            <div class="d-flex items-center">
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Adults', false)"><i class="icon-minus text-12"></i></button>
                              <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get('room2Adults')?.value }}</div></div>
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Adults', true)"><i class="icon-plus text-12"></i></button>
                            </div>
                          </div>
                        </div>
                        <div class="border-top-light mt-24 mb-24"></div>
                        <div class="row y-gap-10 justify-between items-center">
                          <div class="col-auto"><div class="text-15 lh-12 fw-500">Çocuk</div></div>
                          <div class="col-auto">
                            <div class="d-flex items-center">
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Children', false)"><i class="icon-minus text-12"></i></button>
                              <div class="flex-center size-20 ml-15 mr-15"><div class="text-15">{{ searchForm.get('room2Children')?.value }}</div></div>
                              <button type="button" class="button -outline-blue-1 text-blue-1 size-38 rounded-4" (click)="updateGuestCountRoom2('room2Children', true)"><i class="icon-plus text-12"></i></button>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="searchForm.get('room2Children')?.value > 0" class="mt-20">
                          <div class="text-15 fw-500 mb-16">2. Oda Çocuk Yaşları</div>
                          <div class="children-ages-grid">
                            <div *ngFor="let age of room2ChildrenAges; let i = index" class="d-flex flex-column items-center">
                              <div class="text-12 fw-500 mb-8">{{ i + 1 }}. Çocuk</div>
                              <select class="child-age-select" (change)="onChildAgeChangeRoom2($event, i)">
                                <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [value]="a" [selected]="a === age">{{ a }} yaş</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>

                <!-- Search Button -->
                <div class="search-btn-wrap">
                  <button type="submit" class="search-btn" [disabled]="isSearching">
                    <svg *ngIf="!isSearching" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    <span *ngIf="isSearching">Aranıyor...</span>
                  </button>
                </div>
              </div>
            </form>

            <!-- Tarihsiz Arama Uyarısı -->
            <div *ngIf="showDateRequiredWarning && isSearchWithoutDate()" class="mt-30">
              <div class="rounded-8 px-30 py-20" style="background-color: #ffe6e6; border: 1px solid #ffcccc;">
                <div class="row items-center y-gap-20">
                  <div class="col-auto">
                    <div class="size-50 rounded-full d-flex items-center justify-center" style="background-color: #ff6b6b;">
                      <i class="icon-alert text-22 text-white"></i>
                    </div>
                  </div>
                  <div class="col">
                    <h4 class="text-18 fw-500 text-dark-1 mb-5">Tarih Seçimi Gerekli</h4>
                    <p class="text-15 text-dark-1 mb-0">
                      Tarih seçimi yapılmadığında, maksimum <strong>1 oda</strong> ve <strong>1 yetişkin</strong> ile arama yapabilirsiniz.
                    </p>
                    <p class="text-14 text-light-1 mt-5 mb-0">
                      Daha fazla oda veya misafir için lütfen giriş ve çıkış tarihlerini seçiniz.
                    </p>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="button -md -dark-1 bg-blue-1 text-white" (click)="toggleCalendar(); showDateRequiredWarning = false">
                      <i class="icon-calendar mr-10"></i>
                      Tarih Seçin
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="layout-pt-md layout-pb-lg">
    <div class="container">
      <div class="row y-gap-30">
        <!-- Filtre Sidebar (Desktop: sol, Mobile: drawer) -->
        <aside class="col-lg-3 hotel-filter-col">
          <app-hotel-filter-sidebar
            [filterResult]="filterResult"
            [loading]="filterLoading"
            [isMobileOpen]="isFilterSidebarOpen"
            [totalCount]="totalCount"
            [isDatelessSearch]="isDatelessSearch"
            (filtersApplied)="onFiltersApplied($event)"
            (mobileClose)="closeFilterSidebar()"
          ></app-hotel-filter-sidebar>
        </aside>

        <div class="col-lg-9">
          <div class="row y-gap-10 items-center justify-between" *ngIf="hotels.length > 0 && !isLoading && !isSearching">
            <div class="col-auto">
              <div class="text-18">
                <span class="fw-500">{{ totalCount > 0 ? totalCount : hotels.length }} otel</span> {{ getLocationLabel()
                }} bulundu
              </div>
            </div>

          </div>
          
          <!-- Minimum Gece Uyarısı -->
          <div *ngIf="hasMinNightRestriction" class="mb-30">
            <div class="rounded-8 px-30 py-20" style="background-color: #fff8e1; border: 1px solid #e0e0e0;">
              <div class="row items-center y-gap-20">
                <div class="col-auto">
                  <div class="size-50 rounded-full d-flex items-center justify-center" style="background-color: #ffc107;">
                    <i class="icon-calendar text-22 text-white"></i>
                  </div>
                </div>
                <div class="col">
                  <h4 class="text-18 fw-500 text-dark-1 mb-5">Minimum Konaklama Süresi</h4>
                  <p class="text-15 text-dark-1 mb-0">
                    {{ minNightMessage }}
                  </p>
                  <p class="text-14 text-light-1 mt-5 mb-0">
                    Lütfen en az <strong>{{ minNightCount }} gece</strong> için tarih seçerek tekrar arama yapınız.
                  </p>
                </div>
                <div class="col-auto">
                  <button type="button" class="button -md -dark-1 bg-blue-1 text-white" (click)="goBackToSearch()">
                    <i class="icon-search mr-10"></i>
                    Tarihleri Değiştir
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Skeleton Loading -->
          <div *ngIf="isSearching || isLoading || isPaginationLoading" class="hotel-list-grid">
            <div *ngFor="let i of [1,2,3,4,5]" class="hotel-card skeleton-card">
              <div class="skeleton-image skeleton-pulse"></div>
              <div class="skeleton-info">
                <div class="skeleton-line skeleton-line--title skeleton-pulse"></div>
                <div class="skeleton-line skeleton-line--stars skeleton-pulse"></div>
                <div class="skeleton-line skeleton-line--detail skeleton-pulse"></div>
                <div class="skeleton-line skeleton-line--detail skeleton-line--short skeleton-pulse"></div>
              </div>
              <div class="skeleton-price">
                <div class="skeleton-line skeleton-line--price skeleton-pulse"></div>
                <div class="skeleton-line skeleton-line--btn skeleton-pulse"></div>
              </div>
            </div>
          </div>

          <!--oteller listesi-->
          <div *ngIf="!isSearching && !isLoading && !isPaginationLoading" class="hotel-list-grid">
            <div *ngFor="let hotel of hotels" class="hotel-card">
              <!-- Sol: Görsel -->
              <div class="hotel-card__image" (click)="viewHotel(hotel)" style="cursor: pointer;">
                <img [src]="hotel.image" [alt]="hotel.name" />
                <!-- İptal Politikası Badge -->
                <span *ngIf="hotel.cancellationPolicy && !hotel.nonRefundable" class="hotel-card__refund-badge">
                  <i class="icon-check mr-5"></i>Ücretsiz İptal
                </span>
                <span *ngIf="hotel.cancellationPolicy && hotel.nonRefundable" class="hotel-card__nonrefund-badge">
                  <i class="icon-close mr-5"></i>İade Edilemez
                </span>
              </div>

              <!-- Orta: Bilgiler -->
              <div class="hotel-card__info">
                <h3 class="hotel-card__name" (click)="viewHotel(hotel)" style="cursor: pointer;">{{ hotel.name }}</h3>

                <!-- Temalar (mobilde gizli, otel detayında görünür) -->
                <div class="hotel-card__themes hide-on-mobile-card" *ngIf="hotel.themes && hotel.themes.length > 0">
                  <span *ngFor="let theme of hotel.themes.slice(0, 3)" class="hotel-card__theme-tag">{{ theme }}</span>
                  <span *ngIf="hotel.themes.length > 3" class="hotel-card__theme-more">+{{ hotel.themes.length - 3 }}</span>
                </div>

      

                <!-- Min gece, Restoran, Bar — tek satır -->
                <div class="hotel-card__facilities" *ngIf="hotel.minNight || hotel.restaurantCount || hotel.barCount">
                  <span *ngIf="hotel.minNight"><i class="icon-bed"></i> Min. {{ hotel.minNight }} gece</span>
                  <span *ngIf="hotel.restaurantCount"><i class="icon-food"></i> {{ hotel.restaurantCount }} Restoran</span>
                  <span *ngIf="hotel.barCount"><i class="icon-juice"></i> {{ hotel.barCount }} Bar</span>
                </div>

                <!-- Ücretsiz iptal tarihi -->
                <div class="hotel-card__cancel-date hide-on-mobile-card" *ngIf="!hotel.nonRefundable && hotel.cancellationOptionDate && isValidCancellationDate(hotel.cancellationOptionDate)">
                  <i class="icon-calendar mr-5"></i>Ücretsiz iptal: {{ hotel.cancellationOptionDate | date:'dd.MM.yyyy' }}
                </div>
              </div>

              <!-- Sağ: Fiyat & CTA -->
              <div class="hotel-card__pricing">
                <div class="hotel-card__dates" *ngIf="!fromNav">
                  {{ hotel.checkIn | date:'dd MMM' }} - {{ hotel.checkOut | date:'dd MMM' }}
                </div>

                <!-- Tarihli arama: Fiyat göster -->
                <div *ngIf="!isDatelessSearch" class="hotel-card__price-block">
                  <div class="hotel-card__price-line">
                    <span class="hotel-card__nights" *ngIf="getNightCount(hotel.checkIn, hotel.checkOut) > 0">
                      {{ getNightCount(hotel.checkIn, hotel.checkOut) }} Gece
                    </span>
                    <span class="hotel-card__price">
                      {{ hotel.price | currency:'TRY':'symbol-narrow':'1.0-0' }}
                    </span>
                  </div>
                  <app-installment-badge *ngIf="hotel.price > 0" [price]="hotel.price" [maxInstallment]="maxInstallment"></app-installment-badge>
                </div>
                
                <!-- Tarihsiz arama: Uyarı göster -->
                <div *ngIf="isDatelessSearch" style="text-align: center; padding: 10px 0;">
                  <p style="margin: 0; font-size: 14px; font-weight: 500; color: #6b7280; line-height: 1.4;">
                    Fiyatı görmek için tarih seçiniz
                  </p>
                </div>
                
                <button *ngIf="!fromNav" type="button" (click)="showDetails(hotel); $event.stopPropagation()" class="hotel-card__cta">
                  Rezervasyon Yap
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </button>
                <button *ngIf="fromNav" type="button" (click)="scrollToSearchAndOpenCalendar(); $event.stopPropagation()" class="hotel-card__cta hotel-card__cta--date">
                  Tarih Seçin
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="border-top-light mt-30 pt-30" *ngIf="totalCount > 0">
            <div class="row x-gap-10 y-gap-20 justify-between md:justify-center" *ngIf="totalPages > 1">
              <!-- Önceki Sayfa Butonu -->
              <div class="col-auto md:order-1">
                <button type="button" class="button -blue-1 size-40 rounded-full border-light"
                  [disabled]="currentPage <= 1 || isPaginationLoading" [class.opacity-50]="currentPage <= 1 || isPaginationLoading"
                  [class.cursor-not-allowed]="currentPage <= 1 || isPaginationLoading" (click)="previousPage()">
                  <i class="icon-chevron-left text-12"></i>
                </button>
              </div>

              <div class="col-md-auto md:order-3">
                <!-- Desktop sayfa numaraları -->
                <div class="row x-gap-20 y-gap-20 items-center md:d-none">
                  <!-- İlk sayfa (eğer görünür sayfalarda değilse) -->
                  <ng-container *ngIf="getPageNumbers()[0] > 1">
                    <div class="col-auto">
                      <button type="button" class="size-40 flex-center rounded-full cursor-pointer"
                        (click)="goToPage(1)">
                        1
                      </button>
                    </div>
                    <div class="col-auto" *ngIf="getPageNumbers()[0] > 2">
                      <div class="size-40 flex-center rounded-full">...</div>
                    </div>
                  </ng-container>

                  <!-- Görünür sayfa numaraları -->
                  <div class="col-auto" *ngFor="let page of getPageNumbers()">
                    <button type="button" class="size-40 flex-center rounded-full cursor-pointer"
                      [class.bg-dark-1]="page === currentPage" [class.text-white]="page === currentPage"
                      [class.bg-light-2]="page !== currentPage" (click)="goToPage(page)">
                      {{ page }}
                    </button>
                  </div>

                  <!-- Son sayfa (eğer görünür sayfalarda değilse) -->
                  <ng-container *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages">
                    <div class="col-auto" *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1">
                      <div class="size-40 flex-center rounded-full">...</div>
                    </div>
                    <div class="col-auto">
                      <button type="button" class="size-40 flex-center rounded-full cursor-pointer"
                        (click)="goToPage(totalPages)">
                        {{ totalPages }}
                      </button>
                    </div>
                  </ng-container>
                </div>

                <!-- Mobile sayfa numaraları -->
                <div class="row x-gap-10 y-gap-20 justify-center items-center d-none md:d-flex">
                  <div class="col-auto" *ngFor="let page of getPageNumbers().slice(0, 3)">
                    <button type="button" class="size-40 flex-center rounded-full cursor-pointer"
                      [class.bg-dark-1]="page === currentPage" [class.text-white]="page === currentPage"
                      (click)="goToPage(page)">
                      {{ page }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Sonraki Sayfa Butonu -->
              <div class="col-auto md:order-2">
                <button type="button" class="button -blue-1 size-40 rounded-full border-light"
                  [disabled]="currentPage >= totalPages || isPaginationLoading" [class.opacity-50]="currentPage >= totalPages || isPaginationLoading"
                  [class.cursor-not-allowed]="currentPage >= totalPages || isPaginationLoading" (click)="nextPage()">
                  <i class="icon-chevron-right text-12"></i>
                </button>
              </div>
            </div>

            <!-- Toplam otel ve sayfa bilgisi (her zaman göster) -->
            <div class="text-center" [class.mt-30]="totalPages > 1" [class.md:mt-10]="totalPages > 1">
              <div class="text-14 text-light-1">
                Toplam {{ totalCount }} otel bulundu
              </div>
              <div class="text-14 text-light-1 mt-5" *ngIf="totalPages > 1">
                Sayfa {{ currentPage }} / {{ totalPages }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Mobile Filter FAB (sadece ≤991px'te görünür) -->
  <button
    type="button"
    class="filter-fab d-none md:d-flex"
    (click)="toggleFilterSidebar()"
    [attr.aria-label]="'Filtreleri aç'"
  >
    <svg class="fab-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
    </svg>
    <span class="fab-label">Filtrele</span>
    <span *ngIf="hasActiveFilters" class="filter-active-dot"></span>
  </button>
</main>